import { Layout } from '~/jobiqo/components/Layout';
import { OrganizationBannerWidget } from '~/jobiqo/components/Organization/Widgets/Banner';
import { OrganizationInfoBoxWidget } from '~/jobiqo/components/Organization/Widgets/InfoBox';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import styles from '../miniSite.module.scss';
import type { OrganizationMiniSiteLayoutProps } from './types';

export const OrganizationMiniSiteLayout = ({
  organization,
  children,
  headerContent,
}: OrganizationMiniSiteLayoutProps) => {
  return (
    // Mini-sites own the top visual area, so the regular site header is hidden.
    <Layout fullWidthContainer={true} hideHeader={true}>
      <OrganizationBannerWidget organization={organization} />
      <div className={styles.headerBar}>
        <OrganizationInfoBoxWidget
          organization={organization}
          miniSite={true}
        />
        {headerContent}
      </div>
      <Main size="xLarge">
        <Spacing size="large" />
        {children}
        <Spacing size="large" />
      </Main>
    </Layout>
  );
};
